// Apply a workspace's custom app icons (favicon + PWA) to the document head after
// /api/me resolves. Only the icons a workspace actually overrides are swapped;
// anything unset keeps the built-in default from index.html / the static manifest.
// Idempotent — safe to call on every refresh. Runs on the tenant portal only
// (App.jsx); the signup/admin hosts never call it.
//
// PWA caveat: an already-installed home-screen app captured its icons at install
// time. A custom icon shows immediately in the browser tab (favicon) and on the
// NEXT install / periodic manifest refresh for the home-screen icon.
export function applyWorkspaceIcons(branding) {
  if (typeof document === 'undefined') return;
  const icons = branding?.icons || {};
  const head = document.head;

  // Point a single link[rel] at `href`, tagged data-ws so we own it and can find it
  // again. Drop any default (non-data-ws) link of the same rel first, so the browser
  // stops preferring the built-in one.
  const setLink = (rel, href) => {
    head.querySelectorAll(`link[rel="${rel}"]:not([data-ws])`).forEach((l) => l.remove());
    let el = head.querySelector(`link[rel="${rel}"][data-ws]`);
    if (!el) {
      el = document.createElement('link');
      el.setAttribute('rel', rel);
      el.setAttribute('data-ws', '');
      head.appendChild(el);
    }
    el.setAttribute('href', href);
    el.removeAttribute('type');
    el.removeAttribute('sizes');
  };

  if (icons.favicon) setLink('icon', icons.favicon);
  if (icons.appleTouch) setLink('apple-touch-icon', icons.appleTouch);
  // Chrome/Android + macOS Safari install from the manifest — point it at the
  // per-workspace manifest whenever a PWA icon OR the header color is customized. The
  // dynamic manifest carries the workspace's name, icons, and header-colored
  // theme_color/background_color (server/src/branding/index.js).
  if (icons.appleTouch || icons.maskable || branding?.linkColor) {
    const mani = head.querySelector('link[rel="manifest"]');
    if (mani) mani.setAttribute('href', '/api/branding/manifest.webmanifest');
  }
}
